import DragDropManagerImpl from './DragDropManagerImpl';
export function createDragDropManager(backendFactory, globalContext, backendOptions, debugMode) {
  var manager = new DragDropManagerImpl(debugMode);
  var backend = backendFactory(manager, globalContext, backendOptions);
  manager.receiveBackend(backend);
  return manager;
}


//////////////////
// WEBPACK FOOTER
// ./~/dnd-core/dist/esm/factories.js
// module id = 658
// module chunks = 4